import type { ChannelType } from './channels.enum'

export class Channel {
    channelId: string
    label: string
    type: ChannelType
    status: number
    token?: string
    sendLimit?: number
    sendWindowFrom?: number
    sendWindowTo?: number
    sendWindowDays?: any[]
    startAt?: Date
    syncAt?: Date
    voipDomain?: string
    voipUsername?: string
    voipPassword?: string
    voipTransport?: string
    userId?: string
    retriesAllowed?: number
    externalId?: string
    externalUrl?: string
    externalName?: string
    metadata?: any
    s10?: number
    s100?: number
    credentials?: ChannelCredentials
}

export class ChannelCredentials {
    token?: string
    wabaPhoneID?: string
    wabaID?: string
    wabaBusinessID: string
    evoDomain?: string
    evoName?: string
    evoID?: string
    uazapiServer?: string
    uazapiName?: string
    uazapiID?: string
    // gmail: os tokens do Google não são devolvidos pela API — só o que é seguro exibir
    googleEmail?: string
    googleScope?: string
}
